import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import HomeView from 'views/Home/Home'

class Home extends Component {
  static propTypes = {
  }

  render() {
    const userDetails = this.props.currentUser
    const redirecUrl = sessionStorage.getItem('RedirectUrl')

    if (userDetails.IsAdmin && !userDetails.SuperAdministrator) {
      this.props.history.push({ pathname: '/admin/admincentre' })
    } else if (redirecUrl != null && redirecUrl !== '') {
      sessionStorage.removeItem('RedirectUrl')
      if (redirecUrl.indexOf('/admin/') > -1) {
        if (userDetails.SuperAdministrator) {
          this.props.history.push({ pathname: '/admin/admincentre' })
        }
      } else {
        window.location.href = redirecUrl
      }
    }

    return (
      <div>
        <HomeView currentUser={userDetails} />
      </div>
    )
  }
}

const mapStateToProps = () => ({
})

export default withRouter(connect(mapStateToProps, {
})(Home))



// WEBPACK FOOTER //
// ./src/containers/Home.js